<!-- Модалка создания/редактирования бота из мессенджера MAX для раздела чат-интеграций -->
<template>
  <BaseModal
    :visible="true"
    :title="modalTitle"
    size="md"
    footer-align="start"
    elevated-footer
    @close="$emit('close')"
  >
    <MaxBotIntegrationForm
      :form-id="formId"
      :initial-data="initialData"
      @save="saveChatProvider"
    />

    <template #footer>
      <base-primary-button
        class="form-btn"
        type="submit"
        :form="formId"
        :disabled="isSubmitting"
      >
        {{ submitLabel }}
      </base-primary-button>
      <base-button
        class="form-btn"
        type="button"
        :disabled="isSubmitting"
        @click="$emit('close')"
      >
        Отмена
      </base-button>
    </template>
  </BaseModal>
</template>

<script>
import MaxBotIntegrationForm from "@/components/Integration/MaxBotIntegrationForm.vue";
import { useChatProviderStore } from "@/stores/chatProviderStore";

export default {
  name: "IntegrationMaxBotIntegrationModal",

  components: {
    MaxBotIntegrationForm,
  },

  props: {
    initialData: {
      type: Object,
      default: null,
    },
  },

  emits: ["close", "action-saved"],

  data() {
    return {
      formId: "max-bot-integration-form",
      isSubmitting: false,
    };
  },

  computed: {
    chatProviderStore() {
      return useChatProviderStore();
    },

    isEditMode() {
      return Boolean(this.initialData?.id);
    },

    modalTitle() {
      return this.isEditMode
        ? "Редактирование бота из мессенджера MAX"
        : "Создание бота из мессенджера MAX";
    },

    submitLabel() {
      if (this.isSubmitting) {
        return this.isEditMode ? "Сохранение..." : "Создание...";
      }

      return this.isEditMode ? "Сохранить" : "Создать бота";
    },
  },

  methods: {
    async saveChatProvider(payload) {
      try {
        this.isSubmitting = true;
        if (this.isEditMode) {
          await this.chatProviderStore.updateChatProvider(
            this.initialData.id,
            payload
          );
        } else {
          await this.chatProviderStore.createChatProvider(payload);
        }
        this.$emit("action-saved");
        this.$emit("close");
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
